import { connect } from 'react-redux'
import { selectTicketSearchTotalCountsByQueryId } from 'selectors/search'
import SearchRawCountView from './view'

const selectFactory = (initialState, initialOwnProps) => {
  const queryId = initialOwnProps.queryId

  return state => {
    const ticketCounts = selectTicketSearchTotalCountsByQueryId(state)
    const count = ticketCounts[queryId]
    return {
      count,
    }
  }
}

export default connect(selectFactory, null)(SearchRawCountView)
